export default "//cloud.imgsmail.ru/cloud.mail.ru/148635/img/build/errors/error-500.png";